const CURRENT_PARTNER_CONTEXT_STORAGE_KEY = `CURRENT_PARTNER_CONTEXT`;
const PREFERRED_PARTNER_CONTEXT_STORAGE_KEY = `PREFERRED_PARTNER_CONTEXT`;

export class Attribution {
  constructor() {
    try {
      this.customer = /** @type {any} */ (window).customer;
      this.partner = /** @type {any} */ (null);

      if (this.customer) return;
    
      const currentPartnerContext = this.getCurrentPartnerContext();
      const preferredPartnerContext = this.getPreferredPartnerContext();
      this.handleSetPartner(currentPartnerContext, preferredPartnerContext);

    } catch (e) {
      console.error(e);
    }
  }

  /**
   * Fetches stored current partner context.
   */
  getStoredCurrentPartnerContext() {
    try {
      const context = localStorage.getItem(CURRENT_PARTNER_CONTEXT_STORAGE_KEY);
      return context ? JSON.parse(context) : null;
    } catch (e) {
      console.warn(e);
      return null;
    }
  }

  /**
   * Stores current partner context.
   * @param {{ sponsorId: string, enrollerId: string }} data - The context data.
   */
  storeCurrentPartnerContext(data) {
    try {
      localStorage.setItem(CURRENT_PARTNER_CONTEXT_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      console.warn(e);
    }
  }

    /**
   * Fetches stored preferred partner context.
   */
  getStoredPreferredPartnerContext() {
    try {
      const context = sessionStorage.getItem(PREFERRED_PARTNER_CONTEXT_STORAGE_KEY);
      return context ? JSON.parse(context) : null;
    } catch (e) {
      console.warn(e);
      return null;
    }
  }

  /**
   * Stores preferred partner context.
   * @param {{ sponsorId: string, enrollerId: string }} data - The context data.
   */
  storePreferredPartnerContext(data) {
    try {
      sessionStorage.setItem(PREFERRED_PARTNER_CONTEXT_STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      console.warn(e);
    }
  }

  /**
   * Fetches the partner context of the attribution link that the user arrives on.
   */
  getCurrentPartnerContext() {
    const urlParams = new URLSearchParams(window.location.search);

    const sponsorIdParam = urlParams.get('sponsorId');
    const enrollerIdParam = urlParams.get('enrollerId');
    if (sponsorIdParam && enrollerIdParam) {
      let context = {
        sponsorId: sponsorIdParam,
        enrollerId: enrollerIdParam
      };
      return context;
    }

    const storedCurrentPartnerContext = this.getStoredCurrentPartnerContext();
    if (storedCurrentPartnerContext) return storedCurrentPartnerContext;

    return null;
  }

  getPreferredPartnerContext() {
    const storedPreferredPartnerContext = this.getStoredPreferredPartnerContext();
    if (storedPreferredPartnerContext) return storedPreferredPartnerContext;

    return null;
  }

  /**
   * Handles set partner.
   * @param {{ sponsorId: string, enrollerId: string }} currentPartnerContext - The current partner context.
   * @param {{ sponsorId: string, enrollerId: string }} preferredPartnerContext - The preferred partner context.
   */
  handleSetPartner(currentPartnerContext, preferredPartnerContext) {
    const context = currentPartnerContext || preferredPartnerContext;
    if (!context) return;

    // SOME API CALL

    this.updateUrlWithContext(context);
    this.storeCurrentPartnerContext(context);
    this.storePreferredPartnerContext(context);
  }

  /**
   * Updates URL with partner context.
   * @param {{ sponsorId: string, enrollerId: string }} context - The partner context.
   */
  updateUrlWithContext(context) {
    const urlParams = new URLSearchParams(window.location.search);

    urlParams.set('sponsorId', context.sponsorId);
    urlParams.set('enrollerId', context.enrollerId);

    window.history.replaceState({}, document.title, window.location.pathname + '?' + urlParams.toString() + window.location.hash);
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  try {
    new Attribution();
  } catch (e) {
    console.error('Failed to initialize Attribution:', e);
  }
})